// ----------------------------------------------------------------------------
// Snippet: Tooltip
// ----------------------------------------------------------------------------
//
// Some JS to handle touch devices
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_tooltip.scss';

// Variables
const TOOLTIP = '.tooltip';
const TOOLTIP_CONTENT = '.tooltip__content';
const VISIBLE_LOCKED_TOOLTIP_CONTENT = '.tooltip__content--visible-locked';
const TOOLTIP_CONTENT_VISIBLE_CLASS = 'tooltip__content--visible';
const TOOLTIP_CONTENT_VISIBLE_LOCKED_CLASS = 'tooltip__content--visible-locked';


// -------------------------------------
// Functions
// -------------------------------------
function openTooltip() {
    const tooltip = this;
    const tooltipContent = tooltip.querySelector(TOOLTIP_CONTENT);

    if (tooltipContent != null) {
        tooltipContent.classList.add(TOOLTIP_CONTENT_VISIBLE_CLASS);

        // Ensure the tooltip stays on the screen
        if (tooltipContent.offsetLeft < 0) {
            tooltipContent.style.left = "15px";
        }
    }
}

function lockVisibleTooltip() {
    const tooltip = this;
    const tooltipContent = tooltip.querySelector(TOOLTIP_CONTENT);

    if (tooltipContent != null) {
        tooltipContent.classList.toggle(TOOLTIP_CONTENT_VISIBLE_LOCKED_CLASS);
    }
}

function closeTooltip() {
    const tooltip = this;
    const tooltipContent = tooltip.querySelector(TOOLTIP_CONTENT);

    if (tooltipContent != null) {
        tooltipContent.classList.remove(TOOLTIP_CONTENT_VISIBLE_CLASS);
    }
}


// If you click anywhere outside the tooltip, close the tooltip
document.body.addEventListener('click', function(event) {
    const tooltip = event.target.closest(TOOLTIP);

    if (tooltip == null) {
        const visibleLockedTooltipContents = document.querySelectorAll(VISIBLE_LOCKED_TOOLTIP_CONTENT);

        visibleLockedTooltipContents.forEach((tooltipContent) => {
            tooltipContent.classList.remove('tooltip__content--visible-locked');
        })
    }
})

document.addEventListener('DOMContentLoaded', function() {
    const tooltips = document.querySelectorAll(TOOLTIP);

    tooltips.forEach((tooltip) => {

        // Open tooltip events
        tooltip.addEventListener('click', openTooltip);
        tooltip.addEventListener('mouseenter', openTooltip);
        tooltip.addEventListener('focusin', openTooltip);

        // Close tooltip events
        tooltip.addEventListener('mouseleave', closeTooltip);
        tooltip.addEventListener('focusout', closeTooltip);

        // Lock tooltip
        tooltip.addEventListener('click', lockVisibleTooltip);
    })
})
